export const ndash = '–'
